import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import Blackout from '../../entities/blackout';

/*
 * Delete/nullify anywhere this blackout is used in other entities
 *
 * @param {Blackout} blackout
 */
export function deleteBlackout(blackout: Blackout, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = blackout.id;
    }

    /* Remove the actual blackout */
    blackout.status = 'D';
    blackout.addedOn = newHRTimestamp();
    blackout.addedBy = getCurrentUserId();
    blackout.importSource = targetImportSource;
    blackout.importId = mergeId;
    store.dispatch(Actions.BlackoutActions.removeBlackoutQueue(blackout));
    
}